import React, { useEffect } from 'react';
import { isAuthenticated } from '../../utils/auth'; 
import { getAppUrlInfo } from '../../utils/urls';

interface Props {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<Props> = ({ children }) => {
  const { accountsUrl,currentUrl} = getAppUrlInfo();

  useEffect(() => {
    if (!isAuthenticated()) {
      window.location.replace(`${accountsUrl}/login?backTo=${currentUrl}`); // Full external redirect
    }
  }, []);

  if (!isAuthenticated()) return null; // Avoid rendering children briefly during redirect

  return <>{children}</>;
};

export default PrivateRoute;
